import credencial from './fotos/credencial.png';
import foto1 from "./fotos/1.png";
import foto2 from "./fotos/2.png";
import foto3 from "./fotos/3.png";
import foto4 from "./fotos/4.png";
import foto5 from "./fotos/5.png";
import foto6 from "./fotos/6.png";
import foto7 from "./fotos/7.png";
import foto8 from "./fotos/8.png";
import foto9 from "./fotos/9.png";
import foto10 from "./fotos/10.png";
import foto11 from "./fotos/11.png";

const slidesContent = [
  {
    title: "",
    description: 'Si cuentas con cobertura de salud recuerda tener a mano la credencial antes de ingresar a la consulta',
    image: credencial,
    link: ''
  },
  {
    title: "",
    description: 'No se debe compartir objetos de uso personal tal como cepillos de dientes, vasos, platos, cubiertos, toallas, ropa, etc.',
    image: foto1,
    link: ''
  },
  {
    title: "",
    description: 'No debe recibir visitas durante el periodo de aislamiento.',
    image: foto2,
    link: ''
  },
  {
    title: "",
    description: 'La presencia de otras personas en el domicilio debe limitarse a lo estrictamente necesario.',
    image: foto3,
    link: ''
  },
  {
    title: "",
    description: 'Debe permamanecer aislado en una habitación individual el mayor tiempo posible.',
    image: foto4,
    link: ''
  },
  {
    title: "",
    description: 'En caso de necesitar una persona que lo asista debe ser una única persona la asignada.',
    image: foto5,
    link: ''
  },
  {
    title: "",
    description: 'En su habitación deberá colocar un contenedor de residuos para la correcta gestión de los mismos.',
    image: foto6,
    link: ''
  },
  {
    title: "",
    description: 'Su ropa, sabanas y toallas deberán colocarse en una bolsa dentro de la habitación del hasta el momento de lavarla.',
    image: foto7,
    link: ''
  },
  {
    title: "",
    description: 'La ropa, sabanas y toallas deberán lavarse por separado al de los otros convientes y en lo posible con agua caliente entre 60 a 90 grados.',
    image: foto8,
    link: ''
  },
  {
    title: "",
    description: 'Limpiar exhaustivamente el baño, luego del uso.',
    image: foto9,
    link: ''
  },
  {
    title: "",
    description: 'Las superficies que se tocan con frecuencia (mesitas de noche, muebles del dormitorio, entre otros).',
    image: foto10,
    link: ''
  },
  {
    title: "",
    description: 'Se recomienda que la limpieza de la habitación de aislamiento la realice usted mismo.',
    image: foto11,
    link: ''
  },
  // {
  //   title: "Test de Memoria",
  //   description: "Intenta encontrar las dos imagenes iguales",
  //   image: memoTest,
  //   link: '',
  //   juego: <PlayGround />
  // },
  // {
  //   title: "Sopa de Letras",
  //   description: "Juega a una sopa de letras buscando países y continentes",
  //   image: sopaDeLetras,
  //   link: '',
  //   juego: <AlphabetSoup />
  // },
]

export default slidesContent;